import React from "react";
import CesiumWrapper from "./CesiumWrapper";

const Map = () => <CesiumWrapper />;

export default Map;
